import { spreadsheet as spreadsheetCore } from '@industriousapps/excelkits-core';
const {
  splitCellRefs,
  getSpreadsheetIndex,
  lettersToIndex,
  indexToLetters
} = spreadsheetCore;
const PREFIX = 'common: utils: widget: update: utils:'; // Lookup resource neseted inside widget

export function lookupTarget(target, src) {
  const targetSegments = target.split('.');
  let nextTarget = targetSegments.shift();

  if (nextTarget.search(/^\d$/) !== -1) {
    nextTarget = parseInt(nextTarget, 10);
  }

  const result = src[nextTarget];

  if (targetSegments.length && typeof result !== 'undefined') {
    return lookupTarget(targetSegments.join('.'), result);
  }

  return result;
} // Lookup parent resource neseted inside widget

export function lookupTargetParent(target, src) {
  const parentSelector = target.split('.').slice(0, -1).join('.');

  if (parentSelector.length >= target.length) {
    throw Error(`${PREFIX} lookupTargetParent: target "${target}" has no parent`);
  }

  return lookupTarget(parentSelector, src);
} // Lookup any section identifier in a target string

export function lookupTargetSection(target) {
  const [, sectionId] = target.split('.');
  return sectionId || '';
} // Determine if a target string is a question update

export function isTargetQuestionUpdate(target) {
  return target.search(/questions\.\d+$/) > -1;
} // Lookup first discoverable format from selections

export function lookupFirstFormatFromSelections(selections, formats) {
  const [firstSelectedFormat] = selections.map(sel => {
    // Use last cell ref to determine if default
    // formatting should apply, so labeling cells
    // is not a concern
    const lastCellRef = splitCellRefs(sel).pop();
    const sheetIndex = getSpreadsheetIndex(sel);
    return (formats[sheetIndex] || {})[lastCellRef || ''];
  }).filter(Boolean);
  return firstSelectedFormat;
} // Converts a spreadsheet range string (e.g., "B2:D5" or "1.A1:C10")
// into a 2D array (matrix) of structured cell address objects.

export function selectionToAddressMatrix(range) {
  let maxRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  // Extract sheet index if present (format: "1.B2:D5")
  const sheetMatch = range.match(/^(\d+)\.(.*)/);
  const sheetIndex = sheetMatch ? parseInt(sheetMatch[1]) : 0;
  const rangeWithoutSheet = sheetMatch ? sheetMatch[2] : range; // Parse the range

  const parts = rangeWithoutSheet.split(':');
  const start = parts[0];
  const end = parts.length > 1 ? parts[1] : start; // If no end, use start
  // Parse the start cell

  const startMatch = start.match(/([A-Z]+)([0-9]+)/);
  if (!startMatch) throw new Error('Invalid start cell format');
  const startColLetter = startMatch[1];
  const startCol = lettersToIndex(startColLetter);
  const startRow = parseInt(startMatch[2]); // Parse the end cell

  const endMatch = end.match(/([A-Z]+)([0-9]*)/);
  if (!endMatch) throw new Error('Invalid end cell format');
  const endColLetter = endMatch[1];
  const endCol = lettersToIndex(endColLetter); // If end row not specified, use startRow + maxRows - 1

  const endRow = endMatch[2] ? parseInt(endMatch[2]) : startRow + maxRows - 1; // Generate the matrix

  const result = [];

  for (let row = startRow; row <= endRow; row++) {
    const rowCells = [];

    for (let col = startCol; col <= endCol; col++) {
      rowCells.push({
        col: col - startCol + 1,
        // 1-indexed relative to startCol
        row: row - startRow + 1,
        // 1-indexed relative to startRow
        ref: `${indexToLetters(col)}${row}`,
        sheet: sheetIndex
      });
    }

    result.push(rowCells);
  }

  return result;
}